import { Facebook, Instagram, Youtube, Linkedin } from "lucide-react";
import { XIcon } from "@/components/XIcon";

const TikTokIcon = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.36 2.2 1.86 3.94 4 4.18v2.94c-1.48.05-2.9-.4-4-1.2v5.63A5.55 5.55 0 1 1 10.9 9v3.02a2.53 2.53 0 1 0 2.6 2.53V3h3z" />
  </svg>
);

export const SOCIAL = [
  { Icon: Facebook, label: "Facebook", url: "https://www.facebook.com/share/18QRJFmDYK/", style: { background: "#1877F2" } },
  { Icon: XIcon, label: "X", url: "https://x.com/findoj1", style: { background: "#000000" } },
  { Icon: Instagram, label: "Instagram", url: "https://www.instagram.com/findloop.io/", style: { background: "linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)" } },
  { Icon: TikTokIcon, label: "TikTok", url: "https://www.tiktok.com/@getfindo.io?_r=1&_t=ZN-98XjFhZe4gA", style: { background: "#000000" } },
  { Icon: Youtube, label: "YouTube", url: "https://www.youtube.com/@getfindo.io1", style: { background: "#FF0000" } },
  { Icon: Linkedin, label: "LinkedIn", url: "https://www.linkedin.com/in/yannick-tagne-b54396426", style: { background: "#0A66C2" } },
];

export function SocialLinks({ size = 17, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-links">
      {SOCIAL.map(({ Icon, label, url, style }) => (
        <a key={label} href={url} target="_blank" rel="noopener noreferrer" aria-label={label}
          data-testid={`social-${label.toLowerCase()}`} style={style}
          className="h-9 w-9 grid place-items-center rounded-full text-white hover:scale-110 hover:brightness-110 transition-all shadow-sm">
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}

export default SocialLinks;
